"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastText = exports.ToastTextContainer = exports.ToastIconContainer = exports.ToastContainer = exports.toastContainerStyles = void 0;
const native_1 = __importDefault(require("styled-components/native"));
const react_native_1 = require("react-native");
const Typography_styles_1 = require("../../atoms/Typography/Typography.styles");
exports.toastContainerStyles = react_native_1.StyleSheet.create({
    container: {
        flex: 0,
        position: 'absolute',
        maxWidth: '100%',
        zIndex: 999999,
        elevation: 999999,
        alignSelf: 'center',
        ...(react_native_1.Platform.OS === 'web' ? { overflow: 'hidden' } : null),
    },
});
exports.ToastContainer = native_1.default.View `
  margin-right: 24px;
  margin-left: 24px;
  padding-right: 20px;
  margin-bottom: 12px;
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  flex-direction: row;
  min-height: 46px;
  align-items: center;
  justify-content: flex-start;
`;
exports.ToastIconContainer = native_1.default.View `
  margin-right: 8px;
  margin-left: 12px;
  height: 24px;
  width: 24px;
`;
exports.ToastTextContainer = native_1.default.View `
  flex-direction: row;
  flex: 1;
  flex-wrap: wrap;
  padding: 9px 0px;
`;
exports.ToastText = native_1.default(Typography_styles_1.PTextLight) `
  font-weight: 300;
`;
